import { Site } from '@platform/shared';
import { User } from '@platform/shared';
import { useCurrentSite } from '@/shared/hooks/use-current-site';
import {
  DefaultError,
  QueryClient,
  QueryKey,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { toast } from 'sonner';
import { useEffect } from 'react';

export function useSuperQuery<
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: (context: { currentSite?: Site | null; currentUser?: User; queryClient: QueryClient }) => UseQueryOptions<
    TQueryFnData,
    TError,
    TData,
    TQueryKey
  > & {
    errorToast?: string;
  },
): UseQueryResult<NoInfer<TData>, TError> {
  const { currentSite } = useCurrentSite();
  const queryClient = useQueryClient();
  const { errorToast, ...useQueryOptions } = options({
    queryClient,
    currentSite,
  });
  const result = useQuery<TQueryFnData, TError, TData, TQueryKey>(useQueryOptions);

  useEffect(() => {
    if (result.error) {
      toast.error(errorToast);
      logger.error(`Не удалось выполнить операцию`, result.error);
    }
  }, [result.error]);

  return result;
}
